









import { useStampStore } from '@/store/stamp';
import { prefixInteger } from '@/utils';
import { computed, defineComponent, getCurrentInstance, ref } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import StampBalance from './stamp-balance.vue';
import { isTencentCharity } from '@/config/tencent-charity';
import { i18n } from '@/i18n';

export default defineComponent({
  name: 'HeaderModule',
  components: {
    StampBalance,
  },
  setup() {
    const stampStore = useStampStore();
    const { globalActInfo } = storeToRefs(stampStore);
    const totalSendNum = computed(() => prefixInteger(globalActInfo.value.totalSendNum, 7));

    const headImg = computed(() => {
      return isTencentCharity() ? i18n('HeadBgNine') : i18n('HeadBg')
    });

    // @ts-ignore
    const isDailyActivity = getCurrentInstance()?.proxy.$ActBaseConf.isDailyActivity;

    return {
      headImg,
      totalSendNum,
      isDailyActivity,
    };
  },
});
